__turbopack_context__.v({
  "className": "montserrat_2cff47d3-module__jMEnqa__className",
});
